<div class="card-container" [style.backgroundColor]="activityCardInfo.color">
  <div class="card-format" [style.height.px]="cardSizeScaled">
    <div class="card-content-container" fxLayout="column" [style.transform]="scaleCard" (click)="goToInfo()">
      <div class="card-date">{{ activityCardInfo.id }} {{ activityCardInfo.owner.name }} </div>
      <!-- <div class="card-date">{{ activityCardInfo.owner.name }}</div> -->
      <div class="card-title" [matTooltip]="activityCardInfo.title">
          <div>{{ activityCardInfo.text }}</div>
      </div>
      <div class="card-description">{{ activityCardInfo.title  ? activityCardInfo.title : 'Sin descripción' }}</div>
      <mat-chip-list aria-label="Categorías" class="card-tag-container" >
        <mat-chip *ngFor="let category of activityCardInfo.tags">
          {{ category ? category.name:'' }}
        </mat-chip>
      </mat-chip-list>
      <!-- <mat-chip-list class="card-tag-container">
        <mat-chip class="card-tag" *ngFor="let tag of activityCardInfo.tags" [style.color]="activityCardInfo.color">
          {{ category.name }}
        </mat-chip>
      </mat-chip-list> -->
      <!-- <div class="card-category">{{ activityCardInfo.categories }}</div> -->
      <div fxFlex></div>
      <div class="card-scene" fxLayout="row" fxLayoutAlign="left center" fxLayoutGap="1em">
        <div>
          <mat-icon>text_snippet</mat-icon>
        </div>
        <div>
          <span>{{ activityCardInfo.number_of_scenes }}</span>
        </div>
      </div>
    </div>
    <div fxFlex></div>
    <div class="buttons-container" fxLayout="column" fxLayoutGap="10px" [style.transform]="scaleCard">
      <div matRipple matRippleCentered="true" matRippleUnbounded="true" class="card-button" *ngIf="!checkLibrary() || canEdit || canDelete">
        <mat-icon [matMenuTriggerFor]="menu">more_horiz</mat-icon>
        <mat-menu #menu="matMenu" [style.transform]="scaleCard">

          <button mat-menu-item (click)="addToGrade()" class="card-menu" *ngIf="!ispublicAct() && (user.isSuperuser || user.isOrgAdmin)"><small>{{'MENU_CARD.LESSONS'|translate}}</small></button>
          <mat-divider *ngIf="!ispublicAct() && (user.isSuperuser || user.isOrgAdmin)"></mat-divider>

          <button mat-menu-item (click)="addToGrade2()" class="card-menu" *ngIf="!ispublicAct() && !user.isOrgAdmin"><small>{{'MENU_CARD.LESSONS'|translate}}</small></button>
          <mat-divider *ngIf="!ispublicAct() && !user.isOrgAdmin"></mat-divider>

          <button mat-menu-item (click)="onEdit()" class="card-menu" *ngIf="(ownActivities() && !ispublicAct())"><small>{{'MENU_CARD.EDIT'|translate}}</small></button>
          <mat-divider *ngIf="(ownActivities() && !ispublicAct())"></mat-divider>

          <button mat-menu-item (click)="copyToMy()" class="card-menu" *ngIf="(activityCardInfo.isPublic || user.isSuperuser || user.isOrgAdmin || ownActivities()|| sameOrganization())"><small>{{'MENU_CARD.COPY_ME'|translate}}</small></button>
          <mat-divider ></mat-divider> <!-- *ngIf="user.isSuperuser || user.isOrgAdmin" -->

          <button mat-menu-item (click)="copyToAnother()" class="card-menu" *ngIf="(user.isSuperuser || user.isOrgAdmin || ownActivities()|| sameOrganization())"><small>{{'MENU_CARD.COPY_OTHER'|translate}}</small></button>
          <mat-divider *ngIf="(user.isSuperuser || user.isOrgAdmin || ownActivities())"></mat-divider>

          <button mat-menu-item (click)="onDeactivate()" class="card-menu" *ngIf="(!ispublicAct() && ownActivities())">
            <small>{{activityCardInfo.isActive ?  ('MENU_CARD.DEACTIVATE'|translate) : ('MENU_CARD.ACTIVATE'|translate) }}</small>
          </button>
          <mat-divider *ngIf="(!ispublicAct() && ownActivities())"></mat-divider>
          <button mat-menu-item (click)="onDelete()" class="card-menu" *ngIf="(!ispublicAct() && ownActivities())"><small>{{'MENU_CARD.DELETE'|translate}}</small></button>
        </mat-menu>

      </div>
      <div fxFlex  (click)="goToInfo()"></div>
      <div matRipple matRippleCentered="true" matRippleUnbounded="true" class="card-button" *ngIf="(!ispublicAct() && ownActivities())">
        <mat-icon (click)="onDeactivate()" matTooltip="{{activityCardInfo.isActive ? 'Desactivar' : 'Activar'}}">
          {{activityCardInfo.isActive ? 'visibility' : 'visibility_off'}}
        </mat-icon>
      </div>
      <div matRipple matRippleCentered="true" matRippleUnbounded="true" class="card-button" *ngIf="auth.currentUser.isSuperuser">
        <mat-icon (click)="onVisibility()" matTooltip="{{activityCardInfo.isPublic ? 'Publica':'Privada'}}">
          {{activityCardInfo.isPublic ? 'public':'public_off'}}
        </mat-icon>
      </div>
    </div>
  </div>
  <div id="overlay"></div>
</div>

